import {Injectable} from '@angular/core';
import {BootstrapLicenseDataService} from '@core/services';
import {LicenseModules} from '@core/modules/license/enums/license-module.enum';

@Injectable({
  providedIn: 'root'
})
export class LicenseModulesService {
  constructor(private bootstrapDataService: BootstrapLicenseDataService) { }

  hasActiveModule(modules: LicenseModules[]): boolean {
    const { modules: activeModules = null } = this.bootstrapDataService.getBootstrapData();

    /** Dostęp "do niczego" */
    if (!modules || (modules && modules.length === 0) || !activeModules) {
      return true;
    }

    for (const key of modules) {
      if (activeModules[key]) {
        return true;
      }
    }
    return false;
  }
}
